import script from "./BattleListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleListModal.vue?vue&type=script&setup=true&lang=js"

import "./BattleListModal.vue?vue&type=style&index=0&id=96815fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96815fcc"]])

export default __exports__